import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/process-session",
          { session_id: sessionId },
          { withCredentials: true }
        );
        await refresh();
        // Clear hash and route to account
        const target = data.is_admin ? "/admin" : "/account";
        window.history.replaceState(null, "", window.location.pathname);
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: "Login failed. Please try again." } });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-spike-elevated flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-spike-blue-light mx-auto animate-spin" />
        <p className="mt-4 font-orbitron text-xs uppercase tracking-[0.3em] text-spike-text-muted">
          Signing you in...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
